<div *ngIf="applicationError" class="container pb-2 mt-4">
	<div class="alert alert-danger" role="alert">
		Si è verificato un problema, riprova più tardi.
	</div>
</div>
<div *ngIf="!applicationError" class="container pb-2 mt-4">
	<h2>Verifica i criteri di ammissione</h2>
	<div class="sticky-top px-4 p-2 my-4  shadow-lg bg-white border">
		<div class="row">
			<div
				*ngFor="let step of steps(); index as sidx"
				class="col-md-3 d-flex justify-content-center"
			>
				<div class="d-flex align-items-center w-100">
					<div class="me-4">
						<!-- Step passed and OK -->
						<i
							*ngIf="currentStep > sidx+1 && !stepInError(sidx+1) && sidx+1 < 4"
							[class]="{'text-primary': currentStep === sidx+1 }"
							class="bi bi-check-circle-fill h1"
						></i>
						<!-- Step passed and KO -->
						<i
							*ngIf="currentStep > sidx+1 && (stepInError(sidx+1) )  && sidx+1 < 4"
							class="text-danger bi bi-exclamation-circle-fill h1"
						></i>
						<!-- Current Step -->
						<i
							*ngIf="currentStep === sidx+1 && sidx+1 < 4"
							[class]="{'text-primary': currentStep === sidx+1 }"
							class="bi bi-circle h1"
						></i>
						<!-- Next steps -->
						<i
							*ngIf="currentStep < sidx+1 && sidx+1 < 4"
							class="bi bi-circle text-light h1"
						></i>

						<!-- Step passed and OK -->
						<i
							*ngIf="currentStep === sidx+1 && sidx+1 === 4 && (this.answer && !stepInError(sidx+1))"
							[class]="{'text-primary': currentStep === sidx+1 }"
							class="text-success bi bi-check-circle-fill h1"
						></i>
						<!-- Step passed and KO -->
						<i
							*ngIf="currentStep === sidx+1 && sidx+1 === 4 && (this.answer && stepInError(sidx+1))"
							class="text-danger bi bi-exclamation-circle-fill h1"
						></i>

						<!-- Next steps -->
						<i
							*ngIf="currentStep < sidx+1 && sidx+1 === 4"
							class="bi bi-circle text-light h1"
						></i>
						<!-- Current Step -->
						<i
							*ngIf="currentStep === sidx+1 && sidx+1 === 4 && !answer"
							[class]="{'text-primary': currentStep === sidx+1 }"
							class="bi bi-circle h1"
						></i>
					</div>
					<div>
						<h4
							class="mb-1"
							[class]="{'text-primary': currentStep === sidx+1 }"
						>
							{{ step.label}}
						</h4>
						<h6 class="mb-0">
							<small>{{ step.description }}</small>
						</h6>
					</div>
					<div *ngIf="sidx+1 < steps().length" class="ms-auto">
						<i class="bi bi-chevron-right"></i>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- File upload or manual insert-->
	<div *ngIf="currentStep === 1">
		<div class="card mt-4">
			<div class="card-body">
				<h3 class="fw-bold">Selezionare la modalità di inserimento dei dati</h3>
				<hr />
				<!-- File or Manual choice-->
				<div class="row">
					<div class="col-md-6">
						<button
							(click)="setInsertMode(uploadMode)"
							class="btn btn-flat-dark p-0 w-100"
						>
							<div
								[class]="{'border-primary' : isUpload(), 'border-2' : isUpload()}"
								class="border p-4 rounded d-flex shadow-lg bg-white"
							>
								<div class="me-4">
									<i
										*ngIf="isUpload()"
										class="bi-circle-fill text-primary h3"
									></i>
									<i *ngIf="!isUpload()" class="bi-circle h3"></i>
								</div>
								<div class="d-flex align-items-center w-100">
									<div class="text-start">
										<h3>Dichiarazione Sostitutiva</h3>
										<p>
											Carica una dichiarazione sostitutiva<br />per precaricare
											i dati automaticamente
										</p>
									</div>
									<div class="ms-auto">
										<i
											[class]="{'text-primary' : isUpload(), 'text-secondary' : !isUpload() }"
											class="bi-file-text-fill h1"
										></i>
									</div>
								</div>
							</div>
						</button>
					</div>
					<div class="col-md-6">
						<button
							(click)="setInsertMode(manualMode)"
							class="btn btn-flat-dark p-0 w-100"
						>
							<div
								[class]="{'border-primary' : isManual(), 'border-2' : isManual()}"
								class="border p-4 rounded d-flex shadow-lg bg-white"
							>
								<div class="me-4">
									<i
										*ngIf="isManual()"
										class="bi-circle-fill text-primary h3"
									></i>
									<i *ngIf="!isManual()" class="bi-circle h3"></i>
								</div>
								<div class="d-flex align-items-center w-100">
									<div class="text-start">
										<h3>Inserimento Manuale</h3>
										<p>Inserisci manualmente<br />laurea ed esami</p>
									</div>
									<div class="ms-auto">
										<i
											[class]="{'text-primary' : isManual(), 'text-secondary' : !isManual() }"
											class="text-secondary bi-pen-fill h1"
										></i>
									</div>
								</div>
							</div>
						</button>
					</div>
				</div>

				<div class="form-group mb-4 mt-4">
					<!-- Certification Upload -->
					<div *ngIf="isUpload()">
						<h4 class="mb-2 me-2 fw-bold">
							Dichiarazione Sostitutiva di Certificazione
						</h4>

						<ngx-file-drag-drop
							*ngIf="!files.length"
							class="uploader"
							[multiple]="false"
							(valueChanged)="onValueChange($event)"
							[emptyPlaceholder]="'Trascina un file o clicca qui per caricare la dichiarazione'"
						>
						</ngx-file-drag-drop>

						<div class="upload-table" *ngIf="files.length">
							<div class="d-flex justify-content-between align-items-center">
								<div>
									<strong>{{ selectedFile?.name }}</strong>
								</div>
								<div>
									<div class="d-flex justify-content-end">
										<button
											[disabled]="documentProcessing"
											(click)="cleanFile()"
											class="btn btn-sm btn-outline-secondary"
										>
											<i class="bi-remove"></i> Carica un altro file
										</button>
									</div>
								</div>
							</div>

							<div
								*ngIf="documentProcessing"
								class="d-flex rounded align-items-center mt-4 bg-light p-4"
							>
								<div
									class="spinner-border me-4"
									role="status"
									aria-hidden="true"
								></div>
								<strong>Elaborazione in corso...</strong>
							</div>

							<!-- Document Parsed Ok -->
							<div
								*ngIf="documentParseOk === true"
								class="rounded shadow-sm p-4 d-flex align-items-center"
							>
								<i class="bi-check-circle-fill text-success h1 mb-0"></i>
								<h4 class="mb-0 ms-4">Documento elaborato con successo</h4>
							</div>

							<!-- Document Parsed Ko -->
							<div
								*ngIf="documentParseOk === false"
								class="rounded shadow-sm p-4 d-flex align-items-center"
							>
								<i
									class="bi bi-exclamation-octagon-fill text-danger h1 mb-0"
								></i>
								<h4 class="mb-0 ms-4">
									Errore nell'elaborazione del documento
								</h4>
							</div>
						</div>
					</div>

					<!--
					<input
						class="form-control"
						type="file"
						#fileInput
						(change)="onFileChange($event)"
						accept="application/pdf"
					/> -->
				</div>

				<div class="form-group mb-4" [hidden]="!showTemplate">
					<label class="mb-2 fw-bold text-primary">Template</label>
					<textarea
						[(ngModel)]="template"
						placeholder="Template question here"
						class="form-control border-primary"
						rows="10"
					></textarea>
				</div>

				<div class="form-group mb-2" *ngIf="isChat()">
					<label class="mb-2 fw-bold">La tua domanda</label>
					<textarea
						[(ngModel)]="question"
						placeholder="es. Che voto di laurea e quali esami devo avere per essere ammesso?"
						class="form-control"
						rows="6"
					></textarea>
				</div>

				<!--<div class="form-group mb-4" *ngIf="!isChat()">
          <button
            [disabled]="isAdmission() && (!admission.degree_type || !admission.exam_vote)"
            class="btn btn-primary ms-auto"
            (click)="save()"
          >
            <i class="bi-save"></i> Salva i dati
          </button>
          <span *ngIf="savingMessage">{{savingMessage}}</span>
        </div>-->
			</div>
		</div>
	</div>

	<!-- Confirm / Edit Info -->
	<div *ngIf="currentStep === 2">
		<div class="card">
			<div class="card-body" *ngIf="!isChat()">
				<div>
					<h3 class="fw-bold">Inserisci i dati del tuo percorso di laurea</h3>
					<hr />
				</div>

				<!--<div class="form-group mb-4 mt-4">
					<h4 class="mb-2 me-2 fw-bold">Nome e Cognome (*)</h4>
					<input
						style="width: 40%;"
						class="form-control"
						type="text"
						[(ngModel)]="admission.name"
					/>
				</div>-->
				<h4 class="mb-2 fw-bold">
					Laurea in possesso o in corso di ottenimento
				</h4>
				<div class="row">
					<div class="col-md-8 mb-2 me-2 degree-type">
						Classe di Laurea
						<ng-select
							[searchable]="true"
							[items]="degreeTypes"
							[(ngModel)]="admission.degree_type"
							bindLabel="value"
							bindValue="key"
							placeholder="Seleziona una laurea"
							class="w-100"
							(change)="resetAnswer()"
						>
						</ng-select>
						<!-- <input class="form-control" type="text" [(ngModel)]="degree_type" /> -->
					</div>
					<div class="col-md-4 degree-vote">
						<span class="text-nowrap">Voto (in 110)</span>
						<ng-select
							[items]="degree_votes"
							[(ngModel)]="admission.exam_vote"
							bindLabel="value"
							bindValue="key"
							(change)="resetAnswer()"
						>
						</ng-select>
						<!-- <input
              class="form-control"
              type="number"
              [(ngModel)]="exam_vote"
              min="60"
              max="110"
            /> -->
					</div>
				</div>
				<div class="form-group mb-4 mt-4" *ngIf="!isChat()">
					<h4 class="mb-2 fw-bold">
						Esami sostenuti -
						<span class="text-muted"
							><b>{{admission.exams.length}}</b> esami inseriti
						</span>
					</h4>
					<div  *ngIf="admission.exams.length>0">
						<div class="d-none d-md-block">
							<div class="row">
								<div class="col-md-2">SSD</div>
								<div class="col-md-6">Descrizione</div>
								<div class="col-md-2">CFU</div>
								<div class="col-md-2"></div>
							</div>
						</div>
						<div *ngFor="let row of admission.exams; let i = index" class="border rounded p-2 mb-2">
							<div class="row">
								<div class="col-md-2 mb-3 mb-sm-0">
                  <div class="d-md-none">SSD</div>
									<!-- <input
                    class="form-control"
                    style="width: 100%;"
                    type="text"
                    [(ngModel)]="exams[i].ssd"
                  /> -->

									<ng-select
                  class="w-100"
										[searchable]="true"
										[clearable]="true"
										[items]="ssds"
										[(ngModel)]="admission.exams[i].ssd"
										bindLabel="key"
										bindValue="key"
										(change)="prePopulateDescription($event, i)"
									>
									</ng-select>
								</div>
								<div class="col-md-6 mb-3 mb-sm-0">
                  <div class="d-md-none">Descrizione</div>
									<input
										class="form-control"
										type="text"
										[(ngModel)]="admission.exams[i].description"
										(change)="resetAnswer()"
									/>
                </div>
								<div class="col-md-2 mb-3 mb-sm-0">
                  <div class="d-md-none">CFU</div>
									<input
										class="form-control"
										type="number"
										[(ngModel)]="admission.exams[i].cfu"
										(change)="resetAnswer(); onlyPositiveNumbers(i)"
                    (paste)="resetAnswer(); onlyPositiveNumbers(i)"
                    (keyup)="resetAnswer(); onlyPositiveNumbers(i)"
									/>
                </div>
								<div class="col-md-2">
									<button
										class="btn btn-secondary ms-1"
										(click)="removeExam(i); resetAnswer()"
									>
										<i class="bi-trash"></i>
									</button>
								</div>
							</div>
						</div>
					</div>
					<div>
						<button
							class="btn  btn-outline-primary mt-2"
							(click)="addExam(); resetAnswer()"
						>
							<i class="bi-plus"></i> Aggiungi Esame
						</button>
					</div>
				</div>

				<div class="form-group mb-4 language-vote" *ngIf="!isChat()">
					<h3 class="mb-2 fw-bold">Competenze linguistiche</h3>
					<ng-select
						[searchable]="true"
						[items]="languageLevels"
						[(ngModel)]="admission.languageLevel"
						bindLabel="value"
						bindValue="key"
						placeholder="Seleziona una lingua"
						(change)="resetAnswer()"
					>
					</ng-select>
				</div>

        <div class="form-group mb-4 language-vote" *ngIf="!isChat()">
					<h3 class="mb-2 fw-bold">Media esami</h3>
					<ng-select
						[(ngModel)]="admission.examsAverage"
						placeholder="Seleziona media esami"
						(change)="resetAnswer()"
					>
          <ng-option *ngFor="let i of examVotes" value="{{i}}">{{i}}</ng-option>
					</ng-select>
				</div>

			</div>
		</div>
	</div>

	<!-- Target Course-->
	<div *ngIf="currentStep === 3">
		<div class="card mt-4">
			<div class="card-body">
				<h3 class="mb-2 fw-bold">
					Seleziona la scuola ed il corso per il quale vuoi verificare
					l'ammissione
				</h3>
				<hr />
				<h4 class="fw-bold">Seleziona la scuola</h4>

				<ng-select
					(change)="course=''; resetAnswer()"
					[searchable]="true"
					[items]="schools"
					[(ngModel)]="school"
					bindLabel="value"
					bindValue="key"
					class="w-100"
				>
				</ng-select>

				<h4 class="mb-2 fw-bold mt-4">
					Seleziona il corso di laurea magistrale per cui vuoi verificare se
					soddisfi i requisiti ammissione
				</h4>
				<!-- <select class="form-control" [(ngModel)]="c">
        <option *ngFor="let course of courses" [value]="course.id">
          {{ capitalizedCourse(course.course) }}
        </option>
      </select> -->

				<ng-select
					[disabled]="!school"
					[searchable]="true"
					[(ngModel)]="course"
					class="w-100"
					(change)="resetAnswer()"
				>
					<ng-option
						*ngFor="let crs of filteredCourseTypes()"
						[value]="crs.key"
						>{{ crs.value }}</ng-option
					>
				</ng-select>
			</div>
		</div>
	</div>

	<!-- Outcome -->
	<div *ngIf="currentStep === 4">
		<div>
			<div class="card mb-5">
				<div class="card-body">
					<div class="d-flex justify-content-between">
						<h3 class="fw-bold">Risultato di ammissibilità</h3>
						<button
							*ngIf="currentStep === 4 && !answer"
							[disabled]="askDisabled()"
							class="btn btn-primary"
							(click)="ask()"
						>
							<i class="bi-send"></i> Verifica l'ammissibilità
						</button>
						<button
							*ngIf="answer"
							class="btn btn-primary"
							[useExistingCss]="true"
							[printTitle]="'Università degli Studi di Padova - Verifica Ammissione'"
							printSectionId="print-section"
							ngxPrint
						>
							<i class="bi-printer"></i>
							Stampa Esito
						</button>
					</div>
					<hr />
					<div
						*ngIf="stepInError(2) || stepInError(3)"
						class="alert alert-danger"
						role="alert"
					>
						Compila correttamente tutti i campi richiesti per verificare
						l'ammissibilità
					</div>
					<div
						*ngIf="asking"
						class="d-flex rounded align-items-center mt-4 bg-light p-4"
					>
						<div
							class="spinner-border me-4"
							role="status"
							aria-hidden="true"
						></div>
						<strong>Elaborazione in corso...</strong>
					</div>

					<div id="print-section">
						<div *ngIf="answer">
							<div
								class="d-flex align-items-center mb-4 px-4 py-2 bg-light rounded"
							>
								<div class="me-4">
									<i
										class="bi h1"
										[ngClass]="isFailure() ? 'bi-exclamation-circle-fill text-danger' : 'bi-check-circle-fill text-success'"
									></i>
								</div>
								<div>
									<h4 class="fw-bold mb-0">
										<!--Ammissione al corso {{ isFailure() ? 'non' : '' }} possibile -->
										{{ isFailure() ? 'NON' : '' }} Idoneo
									</h4>
									<h5>{{ schoolByKey(school) }} - {{ courseByKey(course) }}</h5>
								</div>
							</div>
							<div
								*ngFor="let condition of reasons; index as i"
								class="condition card border"
							>
								<div class="card-body">
									<h4 class="mb-2 fw-bold text-secondary">
										{{ i+1 }}. {{ condition.label }}
									</h4>
									<!-- {{ condition | json }} -->
									<!-- {{getObjectValues(condition) | json }} -->
									<div
										*ngFor="let subcondition of getObjectValues(condition.subconditions), index as c"
										class="subcondition bg-light p-2 rounded mb-2"
									>
										<!-- {{ subcondition | json }} -->
										<div class="row">
											<div class="col-md-9">
												<h5
													class="mb-2 fw-bold"
													*ngIf="getObjectKeys(condition.subconditions).length > 1"
												>
													Alternativa {{ c + 1 }}
												</h5>
											</div>
											<!-- <div class="col-md-6">
                      <p class="mb-0">{{ subcondition.text }}</p>
                    </div> -->
											<div class="col text-end">
												<!-- <i class="bi bi-check-circle text-success h3"></i> -->
											</div>
										</div>
										<div
											class="bg-white mb-2 p-2 rounded"
											*ngFor="let subsubcondition of subcondition.message"
										>
											<div class="d-flex align-items-center">
												<div class="me-4">
													<i
														class="bi"
														[ngClass]="subsubcondition.passed ? 'bi-check-circle-fill text-success' : 'bi-exclamation-circle-fill text-danger'"
													></i>
												</div>
												<div class="w-full">
													<h6 class="mb-0">
														{{ subsubcondition.message }}
													</h6>
												</div>
												<!-- <div class="col-md-6">
                        {{ subsubcondition.text }}
                      </div> -->
											</div>
										</div>
									</div>
									<div
										*ngIf="isLanguage(condition) && allAlternativesFailed(condition)"
										class="bg-info-subtle px-2 py-1 rounded"
									>
										Verifica le altre modalità di acquisizione del requisito linguistico a questo <a [href]="dipartimento.link" target="_blank">link <i class="bi bi-box-arrow-up-right ms-1"></i></a>
									</div>
								</div>
							</div>
							<hr />
							<div class="my-2" *ngIf="documentUrl()">
								<h3>Documentazione</h3>
								<div class="row">
									<div class="col-md-6">
										<a
											class="btn w-100 btn-outline-primary"
											target="_blank"
											[href]="documentUrl()"
											><i class="bi bi-download me-2"></i> Avviso di
											ammissione</a
										>
									</div>
									<!-- <div class="col-md-6">
                    <a class="btn w-100 btn-outline-primary" target="_blank" href="http://unipd.distribution.s3-website.eu-central-1.amazonaws.com/UUID.pdf."><i class="bi bi-download me-2"></i> Dettagli ammissione facoltà</a>
                  </div> -->
								</div>
							</div>
							<hr />
							<div>
								<div class="p-2 bg-light">
									<i class="bi-info-circle me-2"></i
									><strong>Disclaimer:</strong>
									<span *ngIf="isFailure()"
										> Il risultato ottenuto tramite questo sistema non preclude
										l’accesso ma è solo un’indicazione.
										Per ulteriori informazioni e chiarimenti è possibile consultare l'Avviso di ammissione
										o contattare il Servizio Tutorato all'indirizzo mail <strong>{{dipartimento.email}}</strong>
										con questo codice: <strong>{{short_id || admission_id}}</strong>.</span
									>
									<span *ngIf="isSuccess()"
										>
										Il risultato ottenuto tramite questo sistema non garantisce
										l’accesso ma è solo un’indicazione. Potrebbe essere necessario
										dover sostituire alcuni esami obbligatori se già sostenuti durante
										il corso di laurea triennale.
										Per ulteriori informazioni e chiarimenti è possibile consultare l'Avviso di ammissione o contattare il Servizio Tutorato all'indirizzo mail <strong>{{dipartimento.email}}</strong>
										con questo codice: <strong>{{short_id || admission_id}}</strong>.</span
									>
								</div>
								<h5 class="mt-2">
<!--
									Contatta la segreteria didattica con questo codice:
									<strong>{{short_id || admission_id}}</strong> per maggiori
									dettagli
-->
								</h5>
							</div>
						</div>

						<!-- <div class="d-flex mt-4" *ngIf="answer">
							<div class="w-100">
								<div
									class="border border-danger p-4 rounded"
									*ngIf="isFailure() && !isChat()"
								>
									<div class="d-flex">
										<div class="me-4">
											<i
												class="bi bi-exclamation-octagon-fill text-danger h1"
											></i>
										</div>
										<div>
											<h4 class="mb-4">
												Ammissione al corso non possibile per:
												{{ schoolByKey(school) }} - {{ courseByKey(course) }}
											</h4>

											<div
												class="p-2 border border-danger mb-2 rounded shadow"
												*ngFor="let reason of getObjectValues(reasons)"
											>
												<h6 *ngIf="getObjectValues(reason).length === 1">
													Questo requisito deve essere soddisfatto
												</h6>
												<h6 *ngIf="getObjectValues(reason).length > 1">
													Almeno uno di questi requisiti deve essere soddisfatto
												</h6>
												<ul>
													<ng-container
														*ngFor="let subreasons of getObjectValues(reason), index as subidx"
													>
														<li
															class="mb-1"
															*ngFor="let subreason of getObjectValues(subreasons)"
														>
															{{ subreason }}
														</li>
														<hr
															*ngIf="subidx+1 < getObjectValues(reason).length"
														/>
													</ng-container>
												</ul>
											</div>

											<div class="mt-2">{{reason}}</div>
											<hr />
											<div>
												<div class="p-2 bg-light">
													<i class="bi-info-circle me-2"></i
													><strong>Disclaimer:</strong> il risultato ottenuto
													tramite questo sistema non preclude l’accesso ma è
													solo un’indicazione. Contattare la segreteria per
													eventuali chiarimenti
												</div>
												<h5 class="mt-2">
													Contatta la segreteria con questo codice:
													<strong>{{short_id || admission_id}}</strong> per
													maggiori dettagli
												</h5>
											</div>
										</div>
									</div>
								</div>

								<div
									class="border border-success p-4 rounded"
									*ngIf="isSuccess() && !isChat()"
								>
									<div class="d-flex align-items-center">
										<div class="me-4">
											<i class="bi bi-check-circle-fill text-success h1"></i>
										</div>
										<div>
											<h4 class="mb-0">
												Ammissione al corso possibile per:
												{{ schoolByKey(school) }} - {{ courseByKey(course) }}
											</h4>
											<hr />
											<div>
												<div class="p-2 bg-light">
													<i class="bi-info-circle me-2"></i
													><strong>Disclaimer:</strong> il risultato ottenuto
													tramite questo sistema non garantisce l’accesso ma è
													solo un’indicazione. Contattare la segreteria per
													eventuali chiarimenti
												</div>
												<h5 class="mt-2">
													Contatta la segreteria con questo codice:
													<strong>{{short_id || admission_id}}</strong> per
													maggiori dettagli
												</h5>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div> -->

						<!-- <div *ngIf="answer" class="mt-4">
							<label class="mb-2 fw-bold">Laurea</label>
							<div>
								Tipo: <b>{{ degreeNameByKey(admission.degree_type) }}</b> | Voto
								(in 110): <b>{{ admission.exam_vote }}</b>
							</div>
							<div class="form-group mt-4 mb-4" *ngIf="!isChat()">
								<label class="mb-2 fw-bold">Esami</label>
								<table class="table" *ngIf="admission.exams.length>0">
									<thead>
										<tr>
											<th>SSD</th>
											<th>Descrizione</th>
											<th>CFU</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let row of admission.exams; let i = index">
											<td style="width: 15%;" class="p-1 pe-2">
												{{admission.exams[i].ssd}}
											</td>
											<td style="width: 55%;" class="p-1">
												{{ admission.exams[i].description }}
											</td>
											<td style="width: 10%;" class="p-1 pe-2">
												{{ admission.exams[i].cfu }}
											</td>
										</tr>
									</tbody>
								</table>
							</div>

							<div class="form-group mb-4 language-vote" *ngIf="!isChat()">
								<label class="mb-2 fw-bold">Competenze linguistiche</label>
								<p>{{ admission.languageLevel }}</p>
							</div>
						</div> -->
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- Wizard Navigation -->
	<div class="fixed-bottom bg-white px-4 py-4">
		<div class="container d-flex justify-content-between">
			<button
				*ngIf="currentStep > 1"
				[disabled]="previousStepDisabled()"
				class="btn btn-secondary"
				(click)="goPreviousStep()"
			>
				<i class="bi-chevron-left"></i> Indietro
			</button>

			<div class="ms-auto">
				<button
					*ngIf="currentStep < 4"
					[disabled]="nextStepDisabled()"
					class="btn btn-primary me-2"
					(click)="goNextStep()"
				>
					Avanti
					<i class="bi-chevron-right"></i>
				</button>
			</div>
		</div>
	</div>

	<div class="form-group mb-2" *ngIf="showTrace">
		<label class="mb-2 fw-bold text-primary">Trace</label>
		<textarea
			[(ngModel)]="trace"
			placeholder="Trace here"
			class="form-control border-primary"
			rows="8"
			readonly
		></textarea>
	</div>

	<div class="mt-4 mb-2 d-flex justify-content-between">
		<div>
			<!-- <button
				[disabled]="asking"
				*ngIf="showTrace"
				class="btn btn-secondary ms-2"
				(click)="askWithPrompt()"
			>
				<i class="bi-send-arrow-up-fill"></i> Invia con Prompt
			</button> -->
		</div>

		<!--<button (click)="toggleTrace()" class="btn btn-flat-dark  ms-auto">
			<i class="bi-body-text"></i> Mostra/Nascondi trace
		</button>-->
	</div>

	<!--<div *ngIf="answer">
		<div class="card">
			<div class="card-body">
				<!--<h3>
					<i class="bi bi-chat-left-text me-2"></i>
					<span>Esito</span>
				</h3>
				<div class="d-flex mt-4">
					<div class="w-100">
						<div
							class="border border-danger p-4 rounded"
							*ngIf="isFailure() && !isChat()"
						>
							<div class="d-flex">
								<div class="me-4">
									<i class="bi bi-exclamation-octagon-fill text-danger h1"></i>
								</div>
								<div>
									<h4>Ammissione al corso non possibile</h4>
									<h5>I seguenti requisiti non sono soddisfatti:</h5>
									<ul class="reasons mt-2 mb-0">
										<li *ngFor="let reason of reasons">{{ reason }}</li>
									</ul>
									<br>
									<span>{{reason}}</span>
								</div>
							</div>
						</div>

						<div
							class="border border-success p-4 rounded"
							*ngIf="isSuccess() && !isChat()"
						>
							<div class="d-flex align-items-center">
								<div class="me-4">
									<i class="bi bi-check-circle-fill text-success h1"></i>
								</div>
								<div>
									<h4 class="mb-0">Ammissione al corso possibile</h4>
									<!-- <h5>I seguenti requisiti sono soddisfatti:</h5>
									<ul class="reasons mt-2 mb-0">
										<li *ngFor="let reason of reasons">{{ reason }}</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>-->
</div>
